import { httpCreate } from './http';

const http = httpCreate('/srv/material-personal-documents');

export const materialPersonalDocuments = {
	use(id, params) {
		return http.post(`/use/${id}`, {}, { params });
	},
};
